import type { ReactNode } from "react";

import type { StackProps } from "@braintrust/braintrust-ui-components";
import { Chip, Stack } from "@braintrust/braintrust-ui-components";
import { BraintrustIcon } from "@braintrust/braintrust-ui-components/Icons";

export const RecommendedByMatcherChip = () => {
  return (
    <Chip
      sx={{
        backgroundColor: `var(--black) !important`,
        color: `var(--white) !important`,
      }}
      label={
        <BidScoreMatchChipLabel
          icon={
            <BraintrustIcon
              style={{
                height: "16px",
                width: "16px",
              }}
            />
          }
          label={ENUMS.SmartMatchingLabels.recommended_by_matcher}
        />
      }
      size="x-small"
    />
  );
};

const BidScoreMatchChipLabel = ({
  icon,
  label,
  sx,
}: {
  icon: ReactNode;
  label: ReactNode;
  sx?: StackProps["sx"];
}) => {
  return (
    <Stack
      direction="row"
      sx={{
        gap: "5px",
        alignItems: "center",
        fontSize: "12px",
        lineHeight: "24px",
        ...sx,
      }}
    >
      {icon}
      {label}
    </Stack>
  );
};
